<template>
  <div id="app">
    <!-- 分页导航栏 -->
    <ul class="pagination">
      <!-- 上一页按钮 -->
      <div class="first_last_Page_box flex_center align_center" @click="goToPage(1)" :disabled="currentPage === 1"><img
          src="@/assets/images/pageturn4.svg" alt="" /> 首页
      </div>
      <li class="flex_center align_center" @click="prevPage" :disabled="currentPage === 1">
        <img class="page_turn_img" src="@/assets/images/pageturn2.svg" alt="">
      </li>
      <!-- 页码列表 -->
      <li class="flex_center align_center" :class="{ active: 1 === currentPage }" @click="goToPage(1)">
        1
      </li>
      <li class="flex_center align_center" v-if="currentPage >= 5">
        ...
      </li>
      <li class="flex_center align_center" v-for="page in pageNumbers" :key="page"
        :class="{ active: page === currentPage }" @click="goToPage(page)">
        {{ page }}
      </li>
      <li class="flex_center align_center" v-if="totalPages > 7 && currentPage < totalPages - 3">
        ...
      </li>
      <li class="flex_center align_center" v-if="totalPages > 6" :class="{ active: totalPages === currentPage }"
        @click="goToPage(totalPages)">
        {{ totalPages }}
      </li>
      <!-- 下一页按钮 -->
      <li class="flex_center align_center " @click="nextPage" :disabled="currentPage === totalPages">
        <img class="page_turn_img" src="@/assets/images/pageturn1.svg" alt="">
      </li>
      <div class="first_last_Page_box flex_center align_center" @click="goToPage(totalPages)"
        :disabled="currentPage === 1">末页 <img src="@/assets/images/pageturn3.svg" alt="" />
      </div>
      <div class="flex_center align_center jump_to_box">
        跳至 <input type="text" v-model="inputValue" v-on:keyup.enter="handleEnter" />
        页
      </div>
    </ul>
  </div>
</template>

<script>
import { userInfo } from "@/utils/api";
export default {
  name: 'navbar',
  props: {
    // total: String
  },
  components: {
  },
  data() {
    return {
      // 每页显示的数据数量
      itemsPerPage: 10,
      // 当前页码，初始为第 1 页
      currentPage: 1,
      inputValue: '',
      totalPages: 9,
      allPageNumber: [],
      pageNumbers: [],
    };
  },
  mounted() {
    // this.handlePageNumbers();
  },
  beforeDestroy() {
  },
  methods: {
    // 处理展示页码数组
    handlePageNumbers(total) {
      this.totalPages = Math.ceil(total / this.itemsPerPage);
      // 创建包含 1 到 10 的数组
      this.allPageNumber = Array.from({ length: this.totalPages }, (_, i) => i + 1);

      if (this.totalPages > 7) {
        if (this.currentPage <= 4) {
          this.pageNumbers = this.allPageNumber.slice(1, 6)
        }

        if (this.currentPage >= 5) {
          if (this.currentPage + 2 <= this.totalPages - 1) {
            this.pageNumbers = this.allPageNumber.slice(this.currentPage - 3, this.currentPage + 2);
          } else {
            this.pageNumbers = this.allPageNumber.slice(this.totalPages - 6, this.totalPages - 1);
          }

        }
      } else {
        this.pageNumbers = this.allPageNumber.slice(1, 6)
      }
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.handlePageNumbers();
        this.$emit('submitPage', this.currentPage)
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.handlePageNumbers();
        this.$emit('submitPage', this.currentPage)
      }
    },
    // 跳转到指定页码
    goToPage(page) {
      this.currentPage = page;
      if (page >= 5) {
        this.handlePageNumbers();
      }
      this.$emit('submitPage', this.currentPage)
    },

    // 回车键
    handleEnter() {
      if (this.inputValue > this.totalPages) {
        return
      }
      // 可以在这里添加更多处理逻辑，如提交表单等
      this.currentPage = Number(this.inputValue);
      if (this.inputValue >= 5) {
        this.handlePageNumbers();
      }
      this.$emit('submitPage', this.currentPage)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* 分页导航栏样式 */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  color: black;
  margin-bottom: 40px;
}

.pagination li {
  margin: 0 5px;
  cursor: pointer;
  width: 49px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #898989;
  font-size: 20px;
  color: #7D7D85;
}

.pagination li.active {
  width: 49px;
  height: 50px;
  margin: 0 5px;
  background: #284187;
  border-radius: 4px;
  border: 1px solid #898989;
  color: #fff;
  font-size: 20px;
}

.first_last_Page_box {
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #898989;
  font-size: 20px;
  color: #7D7D85;
  cursor: pointer;
  margin: 0 5px;
  padding: 0 20px;
}

.first_last_Page_box img {
  height: 22px;
}

.page_turn_img {
  width: 15px;
  height: auto;
}

.jump_to_box {
  font-size: 20px;
  color: #7D7D85;
  cursor: pointer;
  margin-left: 15px;
}

.jump_to_box input {
  font-size: 20px;
  color: #7D7D85;
  cursor: pointer;
  width: 72px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #898989;
  outline: none;
  margin: 0 10px;
}
</style>